import React, { useEffect, useState } from 'react'
import { useGeneralParams } from '../../../../hooks/useDataPaginate'
import { formatDateWithTime } from '../../../../utils/dateFormat'
import { MinimalActionButton } from '../../../../components/form/minimalActionButton'
import { useSelector } from 'react-redux'
import { FilterSelect } from '../../../../components/form/FilterSelect'
import { UpdateValuesModal } from '../../../../FormSchemes/GeneralFunctions'
import { DeleteValues } from '../../../../FormSchemes/CuadernoHistorialScheme'
import { DefaultParamsForRecall } from '../../../../utils/defaulStates'
import { Callers } from '../../../../hooks/Callers'
import { DefaultMultiSelectVendedores } from '../../../../components/defaults'
import { badgeStaticFormatCssStyle } from '../../../../utils/styleFormat'
import Tooltip from '../../../../components/tooltips/Tooltip'
import { exportCuadernoToPdf, exportCuadernoToExcel } from '../../../../utils/exportCuaderno'
import { GenerateDocFile } from '../../../../utils/generateDoc'

const ActionBtn = ({ type, icon, tooltipText, onClick, disabled }) => {
    const colorMap = {
        edit: 'yellow', yellow: 'yellow',
        delete: 'red', red: 'red',
        view: 'cyan', cyan: 'cyan',
        green: 'green', blue: 'blue',
    }
    const color = disabled ? 'gray' : (colorMap[type] ?? type)
    return (
        <Tooltip text={tooltipText}>
            <button
                className={`flex h-8 w-8 justify-center items-center dark:text-${color}-500 text-${color}-500 dark:hover:bg-gray-900 hover:bg-stone-200 rounded-md cursor-pointer`}
                onClick={onClick}
                disabled={disabled}
            >
                <i className={`fa-solid ${icon} text-lg`} />
            </button>
        </Tooltip>
    )
}

const NumCell = ({ value, color }) => (
    <div className='flex justify-end'>
        <div className={`${color ?? 'dark:bg-gray-800 bg-green-100'} dark:text-gray-300 text-gray-700 px-1 font-semibold rounded-sm`}>
            {value}
        </div>
    </div>
)

const ExpandableRow = ({ item, onRedirect, onDelete }) => {
    const [expanded, setExpanded] = useState(false)

    const hasVentas = item.ventas_por_producto?.length > 0
    const hasExplicacion = item.explicacion && Object.keys(item.explicacion).length > 0
    const hasDesglose = hasVentas || hasExplicacion

    return (
        <>
            <tr
                className='group bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer'
                onDoubleClickCapture={() => onRedirect(item)}
            >
                <td className='border border-gray-300 dark:border-gray-800 transition-all duration-1000 ease-in-out'>
                    <div className='px-2 py-1 text-gray-900 dark:text-white flex items-center gap-1.5'>
                        <i className='fa-regular fa-clipboard text-green-600 text-xl hidden sm:block' />
                        <div className='pl-2'>
                            <div className='font-semibold'>
                                <span
                                    // className='flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full'
                                    // style={badgeStaticFormatCssStyle(item.codigo)}
                                >
                                    {item.codigo}
                                </span>
                            </div>
                        </div>
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800 transition-all duration-1000 ease-in-out'>
                    <div className='px-2 py-1 text-gray-900 dark:text-white'>
                        <div className='font-semibold'>{item.nombre_completo}</div>
                        <div className='font-semibold text-xs text-gray-400 dark:text-gray-500'>{item.roles}</div>
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'><NumCell value={item.efectivo_total} /></div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'><NumCell value={item.transferencia_total} color='dark:bg-gray-800 bg-blue-100' /></div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'><NumCell value={item.garantias_total_efectivo} color='dark:bg-gray-800 bg-yellow-100' /></div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'><NumCell value={item.garantias_total_transferencia} color='dark:bg-gray-800 bg-orange-100' /></div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1'><NumCell value={item.efectivo_total_neto} color='dark:bg-gray-700 bg-green-200' /></div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1 text-gray-900 dark:text-white flex'>
                        <div
                            className='flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full'
                            style={badgeStaticFormatCssStyle(item.revisado ? 'Revisado' : 'Pendiente')}
                        >
                            {item.revisado ? 'Revisado' : 'Pendiente'}
                        </div>
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div className='px-2 py-1 text-gray-900 dark:text-white'>
                        <span className='italic text-xs'>{formatDateWithTime(item.createdAt)}</span>
                    </div>
                </td>

                <td className='border border-gray-300 dark:border-gray-800'>
                    <div
                        className='px-2 py-1 flex flex-row gap-2'
                        onClick={e => e.stopPropagation()}
                    >
                        {hasDesglose && (
                            <Tooltip text='Ver desglose'>
                                <button
                                    className={`flex h-8 w-8 justify-center items-center rounded-md cursor-pointer
                                        ${expanded
                                            ? 'text-blue-500 dark:text-blue-400'
                                            : 'text-blue-400 dark:text-blue-500 dark:hover:bg-gray-900 hover:bg-stone-200'}`}
                                    onClick={() => setExpanded(p => !p)}
                                >
                                    <i className={`fa-solid fa-chevron-${expanded ? 'up' : 'down'} text-lg`} />
                                </button>
                            </Tooltip>
                        )}

                        <ActionBtn
                            type='cyan'
                            icon='fa-share-from-square'
                            tooltipText='Detalles de cuaderno'
                            onClick={() => onRedirect(item)}
                        />

                        <ActionBtn
                            type='delete'
                            icon='fa-trash'
                            tooltipText='Revertir cuaderno'
                            onClick={() => onDelete(item)}
                            disabled={!item.abierto === false || item.revisado === false}
                        />
                </div>
                </td>
            </tr>

            {expanded && hasDesglose && (
                <tr className='bg-gray-50 dark:bg-gray-800/60'>
                    <td
                        colSpan={10}
                        className='border border-gray-300 dark:border-gray-800 px-4 py-3'
                    >
                        <div className='flex flex-wrap gap-4'>

                            {hasExplicacion && (
                                <div className='flex-1 min-w-[200px]'>
                                    <p className='text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5 flex items-center gap-1.5'>
                                        <i className='fa-solid fa-calculator text-gray-400' />
                                        Explicación del cálculo
                                    </p>
                                    <div className='flex flex-col gap-2'>
                                        <table className='w-full text-xs border border-gray-300 dark:border-gray-700'>
                                            <thead className='text-xs bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                                <tr>
                                                    <th colSpan={2} className='px-2 py-1.5 border border-gray-600 dark:border-gray-800 text-left'>
                                                        <i className='fa-solid fa-money-bill-wave mr-1 text-green-400' />Efectivo
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    ['Ventas efectivo', item.explicacion.efectivo?.ventas_efectivo, null],
                                                    ['Cobros efectivo', item.explicacion.efectivo?.cobros_efectivo, null],
                                                    ['Gastos', '-'+ item.explicacion.efectivo?.gastos, 'text-red-500 dark:text-red-400'],
                                                    ['Total Efectivo', item.explicacion.efectivo?.efectivo_final, 'font-bold text-gray-900 dark:text-white'],
                                                ].map(([label, value, cls]) => (
                                                    <tr key={label} className='bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800 text-gray-500 dark:text-gray-400'>{label}</td>
                                                        <td className={`px-2 py-1 border border-gray-300 dark:border-gray-800 text-right font-mono text-gray-700 dark:text-gray-300 ${cls ?? ''}`}>{value}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <table className='w-full text-xs border border-gray-300 dark:border-gray-700'>
                                            <thead className='text-xs bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                                <tr>
                                                    <th colSpan={2} className='px-2 py-1.5 border border-gray-600 dark:border-gray-800 text-left'>
                                                        <i className='fa-solid fa-sigma mr-1 text-blue-400' />Neto
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[
                                                    ['Total Efectivo', item.explicacion.neto?.efectivo_final, null],
                                                    ['Transferencias', item.explicacion.neto?.transferencias_final, 'text-blue-600 dark:text-blue-400'],
                                                    ['Garantía efectivo', item.explicacion.neto?.garantia_efectivo, 'text-yellow-600 dark:text-yellow-400'],
                                                    ['Garantía transfer.', item.explicacion.neto?.garantia_transferencia, 'text-orange-600 dark:text-orange-400'],
                                                    ['Total Efectivo Neto', item.explicacion.neto?.neto_final, 'font-bold text-gray-900 dark:text-white'],
                                                    ['Diferencia neto', item.explicacion.neto?.diff_neto,
                                                        item.explicacion.neto?.diff_neto === '0,00'
                                                            ? 'text-green-600 dark:text-green-400 font-semibold'
                                                            : 'text-red-600 dark:text-red-400 font-bold'],
                                                ].map(([label, value, cls]) => (
                                                    <tr key={label} className='bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800 text-gray-500 dark:text-gray-400'>{label}</td>
                                                        <td className={`px-2 py-1 border border-gray-300 dark:border-gray-800 text-right font-mono text-gray-700 dark:text-gray-300 ${cls ?? ''}`}>{value}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {hasVentas && (
                                <div className='flex-[2] min-w-[300px]'>
                                    <p className='text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5 flex items-center gap-1.5'>
                                        <i className='fa-solid fa-boxes-stacked text-gray-400' />
                                        Ventas por producto
                                    </p>
                                    <table className='w-full text-xs border border-gray-300 dark:border-gray-700'>
                                        <thead className='text-xs bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'>
                                            <tr>
                                                {['Producto', 'V. Efectivo', 'V. Transfer.', 'G. Efectivo', 'G. Transfer.'].map(h => (
                                                    <th key={h} className='px-2 py-1.5 border border-gray-600 dark:border-gray-800 text-left font-semibold'>
                                                        {h}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.ventas_por_producto.map((vp, idx) => {
                                                const isTotal = vp.producto_id === null
                                                return (
                                                    <tr
                                                        key={idx}
                                                        className={isTotal
                                                            ? 'bg-gray-600 dark:bg-gray-800 text-white font-semibold'
                                                            : 'bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'
                                                        }
                                                    >
                                                        <td className={`px-2 py-1 border border-gray-300 dark:border-gray-800 font-semibold ${isTotal ? 'text-gray-100' : 'text-gray-700 dark:text-gray-300'}`}>
                                                            {isTotal && <i className='fa-solid fa-equals mr-1 text-gray-300 text-[10px]' />}
                                                            {vp.producto}
                                                        </td>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800'>
                                                            {isTotal
                                                                ? <div className='flex justify-end font-mono text-white'>{vp.ventas_efectivo}</div>
                                                                : <NumCell value={vp.ventas_efectivo} />}
                                                        </td>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800'>
                                                            {isTotal
                                                                ? <div className='flex justify-end font-mono text-blue-200'>{vp.ventas_transferencia}</div>
                                                                : <NumCell value={vp.ventas_transferencia} color='dark:bg-gray-800 bg-blue-100' />}
                                                        </td>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800'>
                                                            {isTotal
                                                                ? <div className='flex justify-end font-mono text-yellow-200'>{vp.garantia_efectivo}</div>
                                                                : <NumCell value={vp.garantia_efectivo} color='dark:bg-gray-800 bg-yellow-100' />}
                                                        </td>
                                                        <td className='px-2 py-1 border border-gray-300 dark:border-gray-800'>
                                                            {isTotal
                                                                ? <div className='flex justify-end font-mono text-orange-200'>{vp.garantia_transferencia}</div>
                                                                : <NumCell value={vp.garantia_transferencia} color='dark:bg-gray-800 bg-orange-100' />}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                        </div>
                    </td>
                </tr>
            )}
        </>
    )
}

export const ListCuadernoTable = ({ globalParams }) => {
    const {
        dispatch,
        data, setData,
        paginate, setPaginate,
        selectedDay, setSelectedDay,
        // selecteds, 
        setSelecteds,
        // selectAllChecked, 
        setSelectAllChecked,
        // isChecked, 
        setIsChecked,
        stateData, setStateData,
        deleteModal, setDeleteModal,
        currentData, setCurrentData,
        formatFilters,
        requestAuthPaginate,
        Paginator,
        Searcher,
        RangeDate,
        TableSection,
        ActionSection,
        Section,
        ModalForm,
        redirect
    } = useGeneralParams({ aditionals: { rolnames: ['carro-distribuidor', 'punto-de-venta'] } })

    const reloadMainTable = useSelector(state => state.login.reloadMainTable)

    const getDataPaginate = async () => {
        await requestAuthPaginate({
            method: 'get',
            url: `/cuadernosRevisados/pag`,
            data: null,
            queries: paginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: { filterBy: '', rolname: globalParams?.rolname }
        })
    }

    useEffect(() => {
        getDataPaginate()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), paginate.revisado, paginate.rolnames, reloadMainTable])

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), paginate.revisado, paginate.rolnames, reloadMainTable])

    const reloadTable = () => {
        Callers(dispatch)
        setSelectAllChecked(false)
        setIsChecked(false)
        setSelecteds([])
    }

    const HEADERS = [
        'Número',
        'Responsable',
        'Efectivo Bs.',
        'Transfer. Bs.',
        'Garantía Ef. Bs.',
        'Garantía Tr. Bs.',
        'Efectivo Neto Bs.',
        'Revisado / Pendiente',
        'Fecha registro',
        'Acciones',
    ]

    const SUM_COLS = [
        'efectivo_total',
        'transferencia_total',
        'garantias_total_efectivo',
        'garantias_total_transferencia',
        'efectivo_total_neto',
    ]

    return (
        <Section>
            <ActionSection>
                <Searcher
                    paginate={paginate}
                    setPaginate={setPaginate}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    options={[
                        { label: 'Nombre', value: 'nombre' },
                        { label: 'Código', value: 'codigo' }
                    ]}
                    reloadTable={reloadTable}
                />
                <div className='flex gap-2 flex-wrap'>
                    <RangeDate
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        paginate={paginate}
                        setPaginate={setPaginate}
                    />
                    <DefaultMultiSelectVendedores
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                    />
                    <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='revisado'
                        options={[
                            { label: 'Revisados y pendientes', value: '' },
                            { label: 'Revisados', value: 'true' },
                            { label: 'Pendientes', value: 'false' }
                        ]}
                    />
                    <MinimalActionButton icon='repeat' label='' action={reloadTable} />
                </div>
            </ActionSection>

            <TableSection stateData={stateData} paginator={Paginator} data={data}>
                
                <div className='overflow-auto'>
                    <div className='flex justify-start gap-2 py-1 px-1'>
                        <GenerateDocFile
                            icon='fa-file-excel'
                            color='green'
                            label='Excel'
                            onClick={() => exportCuadernoToExcel(data?.data ?? [])}
                        />
                        <GenerateDocFile
                            icon='fa-file-pdf'
                            color='red'
                            label='PDF'
                            onClick={() => exportCuadernoToPdf(data?.data ?? [])}
                        />
                    </div>
                    <table className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>

                        <thead className='text-xs text-gray-100 capitalcase bg-gray-600 dark:bg-gray-900 dark:text-gray-300'>
                            <tr>
                                {HEADERS.map(h => (
                                    <th
                                        key={h}
                                        scope='col'
                                        className='px-2 py-3 border border-gray-600 dark:border-gray-800 bg-gray-600 dark:bg-gray-900 text-gray-200 dark:text-gray-400'
                                    >
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {Array.isArray(data?.data) && data.data.map(item => (
                                <ExpandableRow
                                    key={item.id}
                                    item={item}
                                    onRedirect={d => redirect(`${d.id}/efectivo`)}
                                    onDelete={d => UpdateValuesModal(d, setCurrentData, setDeleteModal)}
                                />
                            ))}

                            {Array.isArray(data?.data) && data.data.length > 0 && (() => {
                                const totals = SUM_COLS.map(col => {
                                    const nums = data.data.map(x =>
                                        x[col] ? parseFloat((x[col] + '').replace(/\./g, '').replace(',', '.')) : 0
                                    )
                                    return nums.reduce((a, b) => a + b, 0)
                                        .toLocaleString('es-BO', { minimumFractionDigits: 2 })
                                })
                                return (
                                    <tr>
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'><div className='p-1' /></td>
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'><div className='p-1' /></td>
                                        {totals.map((val, i) => (
                                            <td key={i} className='px-2.5 text-white text-right font-semibold bg-gray-600 dark:bg-gray-800'>
                                                <div className='p-1'>{val}</div>
                                            </td>
                                        ))}
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'><div className='p-1' /></td>
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'><div className='p-1' /></td>
                                        <td className='px-2.5 bg-gray-300 dark:bg-gray-900'><div className='p-1' /></td>
                                    </tr>
                                )
                            })()}
                        </tbody>
                    </table>
                </div>
            </TableSection>

            {deleteModal && (
                <ModalForm
                    setModal={setDeleteModal}
                    label='¿Revertir el proceso de ingreso de cuaderno?'
                    dataValues={DeleteValues(currentData)}
                    urlApi={`/efectivoHistorial/cuaderno/${currentData.id}`}
                    method={'delete'}
                    call={reloadTable}
                    buttonLabel='Eliminar'
                />
            )}
        </Section>
    )
}